import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from './../fields';

const formFields: (IFieldContainer | IFieldDefinition)[] = [
	fieldsMap.get('code'),
	fieldsMap.get('payment_type_id'),
	fieldsMap.get('notify_booking_events')
];

const config: IFormConfig = {
	fields: formFields,
};

export default config;
